import { Suspense } from 'react';
import Shimmer from '~/components/Shimmer';
import { usePendingUser } from './hooks';
import { PendingUserPresentation } from './presentations';

const LegacyPendingUserListInner = () => {
  const {
    state: {
      filteredUsers,
      isLoading,
      currentPage,
      totalPage,
      totalCount,
      totalPendingCount,
      isBulkSendReminderModalOpen,
      errMsg,
      isErrorMessageModalOpen,
      isCompleteModalOpen,
      disableRowNavigation,
    },
    actions: {
      handlePageChange,
      handleBulkSendReminder,
      handleOutputCsv,
      handleHeaderSort,
      setIsBulkSendReminderModalOpen,
      setIsErrorMessageModalOpen,
      setIsCompleteModalOpen,
    },
  } = usePendingUser();

  return (
    <PendingUserPresentation
      filteredUsers={filteredUsers}
      isLoading={isLoading}
      currentPage={currentPage}
      totalPage={totalPage}
      totalCount={totalCount}
      totalPendingCount={totalPendingCount}
      isBulkSendReminderModalOpen={isBulkSendReminderModalOpen}
      errMsg={errMsg}
      isErrorMessageModalOpen={isErrorMessageModalOpen}
      isCompleteModalOpen={isCompleteModalOpen}
      handlePageChange={handlePageChange}
      handleBulkSendReminder={handleBulkSendReminder}
      handleOutputCsv={handleOutputCsv}
      handleHeaderSort={handleHeaderSort}
      setIsBulkSendReminderModalOpen={setIsBulkSendReminderModalOpen}
      setIsErrorMessageModalOpen={setIsErrorMessageModalOpen}
      setIsCompleteModalOpen={setIsCompleteModalOpen}
      disableRowNavigation={disableRowNavigation}
    />
  );
};

/**
 * 初回ログイン未完了者一覧（レガシーUI）Container
 *
 * `usePendingUser` は内部でパートナー機能フラグ取得に suspense 前提の共通 hook
 * （`useGetClientAdminsPartnerFeatureFlags`）を使用する。この画面は
 * `screens/LegacyPendingUser` にも `DashboardLayout` にも Suspense 境界が無いため、
 * Screen 側を変更せずに済むよう Suspense 境界をこの Container 内部に閉じる。
 *
 * NOTE: フォールバック中に表示される Shimmer は、Presentation 内部が持つ
 * `isLoading`（一覧データ取得中）の Shimmer 表示と見た目を揃えている。
 */
export const LegacyPendingUserList = () => (
  <Suspense fallback={<Shimmer />}>
    <LegacyPendingUserListInner />
  </Suspense>
);
